export const processLineChartData = (
  data,
  {
    dateKey = "date",
    metrics = [],
    dateFormat = { month: "short", day: "numeric" },
  },
) => {
  const sortedData = [...data].sort(
    (a, b) => new Date(a[dateKey]) - new Date(b[dateKey]),
  );

  const categories = sortedData.map((item) =>
    new Date(item[dateKey]).toLocaleDateString("en-US", dateFormat),
  );

  const seriesData = metrics.map((metric) => ({
    name: metric.label || metric.key,
    data: sortedData.map((item) => item[metric.key]),
  }));

  return { categories, seriesData };
};

export const processBarChartData = (
  data,
  { categoryKey, valueKey, seriesName } = {},
) => {
  const categories = data.map((item) => item[categoryKey]);

  const seriesData = [
    {
      name: seriesName,
      data: data.map((item) => item[valueKey]),
    },
  ];

  return { categories, seriesData };
};
